import { OfferSortField, SortDirection, } from "../transform-offer-alternatives/types/goliath.types.js";
const config = {
    separators: {
        path: "/",
        item: "+",
        filter: "_",
    },
    prefixes: {
        filter: "_",
        page: "seite-",
    },
    pathPrefix: "/suche",
    filters: [
        {
            name: "brandSlugs",
            multiple: true,
            placeholder: "alle-hersteller",
        },
        {
            name: "colorSlugs",
            multiple: true,
            placeholder: "alle-farben",
        },
        {
            name: "compatibleProductFamilySlugs",
            multiple: true,
            prefix: "fuer-",
            placeholder: "alle-geraete",
        },
        {
            name: "productTagSlugs",
            multiple: true,
            placeholder: "alle-produkte",
        },
    ],
    sortMap: {
        recommendation: {
            __typename: "OfferSort",
            field: OfferSortField.Recommendation,
            direction: SortDirection.Asc,
        },
        relevance: {
            __typename: "OfferSort",
            field: OfferSortField.Relevance,
            direction: SortDirection.Asc,
        },
        priceAsc: {
            __typename: "OfferSort",
            field: OfferSortField.OnetimePrice,
            direction: SortDirection.Asc,
        },
        priceDesc: {
            __typename: "OfferSort",
            field: OfferSortField.OnetimePrice,
            direction: SortDirection.Desc,
        },
        nameAsc: {
            __typename: "OfferSort",
            field: OfferSortField.Name,
            direction: SortDirection.Asc,
        },
        nameDesc: {
            __typename: "OfferSort",
            field: OfferSortField.Name,
            direction: SortDirection.Desc,
        },
        new: {
            __typename: "OfferSort",
            field: OfferSortField.InsertedAt,
            direction: SortDirection.Desc,
        },
    },
    queryParameters: [
        {
            name: "discounted",
            pattern: /^(true|false)$/,
            parser: (value) => value === "true",
        },
        {
            name: "productProviders",
            parser: (value) => /^(TELEKOM|BRODOS)$/.test(value) ? [value] : undefined,
        },
    ],
    defaultSort: "recommendation",
    defaultPageSize: 48,
};
export default config;
